import * as React from 'react'
import { SVGProps } from 'react'

const ETCUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.9072 22.3038L24.0624 16.9578L34.1345 22.3369L24.0181 7.5L13.9072 22.3038ZM14.2969 23.8479L24.0757 18.6299L33.7272 23.8098L24.0812 29.0336L14.2969 23.8479ZM13.9072 25.3421C17.4712 27.2348 21.1901 29.2159 24.0624 30.7489L34.1345 25.3421C30.4875 30.7599 27.4489 35.2704 24.0624 40.2621L22.1048 37.3884C19.2774 33.238 16.3523 28.9441 13.9072 25.3421Z'
      fill='#3AB83A'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24.0146 7.5L24.059 16.9582L34.131 22.3369L24.0146 7.5ZM24.0703 18.6296L33.7218 23.8095L24.0758 29.0334L24.0703 18.6296ZM24.0557 30.7486L34.1277 25.3418C30.4808 30.7596 24.0557 40.2619 24.0557 40.2619V30.7486Z'
      fill='#0B8311'
    />
    <path d='M14.291 23.8471L24.0704 24.6497L33.7219 23.814L24.0753 29.0382L14.291 23.8471Z' fill='#0B8311' />
    <path d='M24.0704 24.6497L33.7219 23.814L24.0753 29.0382L24.0704 24.6497Z' fill='#146714' />
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
  </svg>
)

export default ETCUSD
